import Filters from '@wwdev/product/filters';
import SearchRequest from "@wwdev/product/SearchRequest";

class Filter extends Filters {
	constructor() {
		super();
		if ($('[package="cms-product"] [data-scope="filters"]').length < 1) {
			return;
		}

		this.initClickEvents();
		this.filterWrapper = '.filters-wrapper';
	}

	initClickEvents() {
		$(this.config.filters).on('click', '.open-filter-menu', this.openMobileFilterMenu.bind(this));
		$(this.config.filters).on('click', '.close-filter-menu', this.closeMobileFilterMenu.bind(this));
		jQuery(this.config.filters).on('click', '[data-author]', this.changeAuthor.bind(this));
		jQuery(this.config.filters).find('[data-author]');
	}


	changeAuthor(event) {
		if (!jQuery(event.target).is('input')) {
			return true;
		}
		$('.filter-option').removeClass('fw-bold');
		$(event.currentTarget).toggleClass('fw-bold');
		let author = null;
		author = [jQuery(event.currentTarget).data('author')];
		SearchRequest.setByKeyValue('author', author);
		this.reload();
		return false;

	}

	beforeCallback() {
		jQuery('#loading').removeClass('d-none');
	}

	afterCallback() {
		this.resetScroll();
		jQuery('#loading').addClass('d-none');
	}

	changeAuthorLetter(event) {
		let letter = null;
		letter = jQuery(event.currentTarget).data('authorLetter');
		if (SearchRequest.request.hasOwnProperty('letter') && SearchRequest.request.letter == letter) {
			SearchRequest.clearByKey('letter');
			SearchRequest.clearByKey('author');
		} else {
			SearchRequest.setByKeyValue('letter', letter);
			SearchRequest.clearByKey('author');
		}
		this.reload();
		return false;
	}

	handleResponse(response) {
		// $(this.config.filters).html(response.filters);
		$(this.config.products).html(response.products);
		$(this.config.paginator).html(response.paginator);
		$(this.config.paginator).html(response.paginator);
		this.initEventListeners();
	}

	resetFilter(e) {
		SearchRequest.clearByKey('letter')
		SearchRequest.clearByKey('author')
		return super.resetFilter();
	}

	openMobileFilterMenu() {
		$('body').addClass('filter-menu-open');
		$(this.filterWrapper).addClass('open');
	}

	closeMobileFilterMenu() {
		$('body').removeClass('filter-menu-open');
		$(this.filterWrapper).removeClass('open');
	}
}

export default Filter;